import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../configs/app.config';

@Component({
  selector: 'blinker-sso',
  template: ''
})
export class SsoComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
    window.addEventListener("message", receiveMessage, false);
    function receiveMessage(event) {
      var origin = event.origin
      console.log(origin);
      if (origin != "http://localhost:4201" && origin != "http://sso2.diandeng.tech" && origin != "https://sso.clz.me" && origin != AppConfig.sso_url)
        return;
      localStorage.setItem('blinker_token_sso', JSON.stringify(event.data));
    }
  }

}
